import type { HttpRequest } from '@angular/common/http';

export function apiPath(url: string, baseUrl: string, documentUrl: string): string | null {
  try {
    const base = new URL(baseUrl, documentUrl);
    const target = new URL(url, documentUrl);
    const prefix = base.pathname.replace(/\/$/, '');
    if (base.origin !== target.origin) return null;
    if (target.pathname !== prefix && !target.pathname.startsWith(`${prefix}/`)) return null;
    return target.pathname.slice(prefix.length) || '/';
  } catch {
    return null;
  }
}

export function isAuthPath(path: string): boolean {
  return ['/auth/me', '/auth/logout'].includes(path) || path.startsWith('/auth/otp/');
}

export function isMutation(method: string): boolean {
  return !['GET', 'HEAD', 'OPTIONS'].includes(method);
}

export function withCurrentCsrf<T>(request: HttpRequest<T>, document: Document): HttpRequest<T> {
  if (!isMutation(request.method)) return request;
  const cookie = document.cookie
    .split(';')
    .map(value => value.trim())
    .find(value => value.startsWith('__csrf='));
  let headers = request.headers.delete('x-csrf-token');
  if (cookie) {
    try {
      headers = headers.set('x-csrf-token', decodeURIComponent(cookie.slice('__csrf='.length)));
    } catch {
      /* Un cookie malformé ne doit pas conserver un ancien jeton. */
    }
  }
  return request.clone({ headers });
}
